import React from 'react'
import { useSelector } from 'react-redux'
import { isCountry, isDepartment, isRegion } from '../../../store/address/address.helpers'
import { selectFirstAddress } from '../../../store/address/address.selectors'
import { selectLocale } from '../../../store/navigation/navigation.selectors'
import { getImagePath } from '../../address/seo/AddressImage.utils'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import { withTranslation } from '../../i18n/T'
import s from '../../map/StaticMap.less'

const getLabel = (t, address) => {
  if (isCountry(address)) {
    return t('zones.country.static_map_img_alt', [address.countryLabel])
  } else if (isRegion(address)) {
    return t('zones.region.static_map_img_alt', [address.regionLabel])
  } else if (isDepartment(address)) {
    return t('zones.department.static_map_img_alt', [address.departmentLabel])
  }
}

const SeoZoneMapImage = ({ t }) => {
  const locale = useSelector(selectLocale)
  const address = useSelector(selectFirstAddress)
  const src = getImagePath(address)

  if (locale.startsWith('en')) return <></>
  if (!src) return <></>

  return <img id="AddressMapImage" src={src} alt={getLabel(t, address)} className={s.StaticMap} />
}

export default withEmptyFallbackErrorBoundary(withTranslation(SeoZoneMapImage))
